const navbarWords ={
    'opt1':{'es':'Inicio','en':'Home'},
    'opt2':{'es':'Trabajos','en':'Projects'},
    'opt3':{'es':'Información','en':'About me'},
    'opt4':{'es':'Contacto','en':'Contact'},
    'swipt':{'es':'Descargar Cv','en':'Download sumary'}
}

export default navbarWords;